import { client } from '@/Apollo';
import { CreateLead } from '../mutation/CreateLead';

const createLeadOrder = (data) => new Promise((resolve, reject) => {
  client
    .mutate({
      mutation: CreateLead,
      variables: { ...data },
    })
    .then((r) => {
      resolve(r.data.createLeadOrderRepair);
    })
    .catch((e) => {
      console.log(e.message, 'erro ao criar');
      reject(e.message);
    });
});

export default createLeadOrder;
